module.exports = __webpack_public_path__ + "img/25.2a59b840.png";